import { useQuery } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { PartnerToken } from 'interfaces/partner-token'

interface PartnerIntegrationResponse {
  data: PartnerToken
}

export default function useGetPartnerIntegration(integrationId: string) {
  return useQuery<PartnerIntegrationResponse, Error>(
    ['partnerIntegration', integrationId],
    async () => {
      const response = await fetch(
        `${BASE_API_URL}/admin/api/v2/partner_integrations/${integrationId}`,
        {
          method: API_METHODS.GET,
          headers: apiHeaders(store.getState()),
        }
      )

      if (!response.ok) {
        throw new Error('Failed to fetch partner integration')
      }

      return response.json()
    },
    {
      enabled: !!integrationId,
    }
  )
}
